// Generated by scripts/generate-geo.ts. Do not edit by hand.
const countries: { code: string; name: string }[] = [
  { code: "AD", name: "countries.AD" },
  { code: "AE", name: "countries.AE" },
  { code: "AF", name: "countries.AF" },
  { code: "AG", name: "countries.AG" },
  { code: "AI", name: "countries.AI" },
  { code: "AL", name: "countries.AL" },
  { code: "AM", name: "countries.AM" },
  { code: "AO", name: "countries.AO" },
  { code: "AQ", name: "countries.AQ" },
  { code: "AR", name: "countries.AR" },
  { code: "AS", name: "countries.AS" },
  { code: "AT", name: "countries.AT" },
  { code: "AU", name: "countries.AU" },
  { code: "AW", name: "countries.AW" },
  { code: "AX", name: "countries.AX" },
  { code: "AZ", name: "countries.AZ" },
  { code: "BA", name: "countries.BA" },
  { code: "BB", name: "countries.BB" },
  { code: "BD", name: "countries.BD" },
  { code: "BE", name: "countries.BE" },
  { code: "BF", name: "countries.BF" },
  { code: "BG", name: "countries.BG" },
  { code: "BH", name: "countries.BH" },
  { code: "BI", name: "countries.BI" },
  { code: "BJ", name: "countries.BJ" },
  { code: "BL", name: "countries.BL" },
  { code: "BM", name: "countries.BM" },
  { code: "BN", name: "countries.BN" },
  { code: "BO", name: "countries.BO" },
  { code: "BQ", name: "countries.BQ" },
  { code: "BR", name: "countries.BR" },
  { code: "BS", name: "countries.BS" },
  { code: "BT", name: "countries.BT" },
  { code: "BV", name: "countries.BV" },
  { code: "BW", name: "countries.BW" },
  { code: "BY", name: "countries.BY" },
  { code: "BZ", name: "countries.BZ" },
  { code: "CA", name: "countries.CA" },
  { code: "CC", name: "countries.CC" },
  { code: "CD", name: "countries.CD" },
  { code: "CF", name: "countries.CF" },
  { code: "CG", name: "countries.CG" },
  { code: "CH", name: "countries.CH" },
  { code: "CI", name: "countries.CI" },
  { code: "CK", name: "countries.CK" },
  { code: "CL", name: "countries.CL" },
  { code: "CM", name: "countries.CM" },
  { code: "CN", name: "countries.CN" },
  { code: "CO", name: "countries.CO" },
  { code: "CR", name: "countries.CR" },
  { code: "CU", name: "countries.CU" },
  { code: "CV", name: "countries.CV" },
  { code: "CW", name: "countries.CW" },
  { code: "CX", name: "countries.CX" },
  { code: "CY", name: "countries.CY" },
  { code: "CZ", name: "countries.CZ" },
  { code: "DE", name: "countries.DE" },
  { code: "DJ", name: "countries.DJ" },
  { code: "DK", name: "countries.DK" },
  { code: "DM", name: "countries.DM" },
  { code: "DO", name: "countries.DO" },
  { code: "DZ", name: "countries.DZ" },
  { code: "EC", name: "countries.EC" },
  { code: "EE", name: "countries.EE" },
  { code: "EG", name: "countries.EG" },
  { code: "EH", name: "countries.EH" },
  { code: "ER", name: "countries.ER" },
  { code: "ES", name: "countries.ES" },
  { code: "ET", name: "countries.ET" },
  { code: "FI", name: "countries.FI" },
  { code: "FJ", name: "countries.FJ" },
  { code: "FK", name: "countries.FK" },
  { code: "FM", name: "countries.FM" },
  { code: "FO", name: "countries.FO" },
  { code: "FR", name: "countries.FR" },
  { code: "GA", name: "countries.GA" },
  { code: "GB", name: "countries.GB" },
  { code: "GD", name: "countries.GD" },
  { code: "GE", name: "countries.GE" },
  { code: "GF", name: "countries.GF" },
  { code: "GG", name: "countries.GG" },
  { code: "GH", name: "countries.GH" },
  { code: "GI", name: "countries.GI" },
  { code: "GL", name: "countries.GL" },
  { code: "GM", name: "countries.GM" },
  { code: "GN", name: "countries.GN" },
  { code: "GP", name: "countries.GP" },
  { code: "GQ", name: "countries.GQ" },
  { code: "GR", name: "countries.GR" },
  { code: "GS", name: "countries.GS" },
  { code: "GT", name: "countries.GT" },
  { code: "GU", name: "countries.GU" },
  { code: "GW", name: "countries.GW" },
  { code: "GY", name: "countries.GY" },
  { code: "HK", name: "countries.HK" },
  { code: "HM", name: "countries.HM" },
  { code: "HN", name: "countries.HN" },
  { code: "HR", name: "countries.HR" },
  { code: "HT", name: "countries.HT" },
  { code: "HU", name: "countries.HU" },
  { code: "ID", name: "countries.ID" },
  { code: "IE", name: "countries.IE" },
  { code: "IL", name: "countries.IL" },
  { code: "IM", name: "countries.IM" },
  { code: "IN", name: "countries.IN" },
  { code: "IO", name: "countries.IO" },
  { code: "IQ", name: "countries.IQ" },
  { code: "IR", name: "countries.IR" },
  { code: "IS", name: "countries.IS" },
  { code: "IT", name: "countries.IT" },
  { code: "JE", name: "countries.JE" },
  { code: "JM", name: "countries.JM" },
  { code: "JO", name: "countries.JO" },
  { code: "JP", name: "countries.JP" },
  { code: "KE", name: "countries.KE" },
  { code: "KG", name: "countries.KG" },
  { code: "KH", name: "countries.KH" },
  { code: "KI", name: "countries.KI" },
  { code: "KM", name: "countries.KM" },
  { code: "KN", name: "countries.KN" },
  { code: "KP", name: "countries.KP" },
  { code: "KR", name: "countries.KR" },
  { code: "KW", name: "countries.KW" },
  { code: "KY", name: "countries.KY" },
  { code: "KZ", name: "countries.KZ" },
  { code: "LA", name: "countries.LA" },
  { code: "LB", name: "countries.LB" },
  { code: "LC", name: "countries.LC" },
  { code: "LI", name: "countries.LI" },
  { code: "LK", name: "countries.LK" },
  { code: "LR", name: "countries.LR" },
  { code: "LS", name: "countries.LS" },
  { code: "LT", name: "countries.LT" },
  { code: "LU", name: "countries.LU" },
  { code: "LV", name: "countries.LV" },
  { code: "LY", name: "countries.LY" },
  { code: "MA", name: "countries.MA" },
  { code: "MC", name: "countries.MC" },
  { code: "MD", name: "countries.MD" },
  { code: "ME", name: "countries.ME" },
  { code: "MF", name: "countries.MF" },
  { code: "MG", name: "countries.MG" },
  { code: "MH", name: "countries.MH" },
  { code: "MK", name: "countries.MK" },
  { code: "ML", name: "countries.ML" },
  { code: "MM", name: "countries.MM" },
  { code: "MN", name: "countries.MN" },
  { code: "MO", name: "countries.MO" },
  { code: "MP", name: "countries.MP" },
  { code: "MQ", name: "countries.MQ" },
  { code: "MR", name: "countries.MR" },
  { code: "MS", name: "countries.MS" },
  { code: "MT", name: "countries.MT" },
  { code: "MU", name: "countries.MU" },
  { code: "MV", name: "countries.MV" },
  { code: "MW", name: "countries.MW" },
  { code: "MX", name: "countries.MX" },
  { code: "MY", name: "countries.MY" },
  { code: "MZ", name: "countries.MZ" },
  { code: "NA", name: "countries.NA" },
  { code: "NC", name: "countries.NC" },
  { code: "NE", name: "countries.NE" },
  { code: "NF", name: "countries.NF" },
  { code: "NG", name: "countries.NG" },
  { code: "NI", name: "countries.NI" },
  { code: "NL", name: "countries.NL" },
  { code: "NO", name: "countries.NO" },
  { code: "NP", name: "countries.NP" },
  { code: "NR", name: "countries.NR" },
  { code: "NU", name: "countries.NU" },
  { code: "NZ", name: "countries.NZ" },
  { code: "OM", name: "countries.OM" },
  { code: "PA", name: "countries.PA" },
  { code: "PE", name: "countries.PE" },
  { code: "PF", name: "countries.PF" },
  { code: "PG", name: "countries.PG" },
  { code: "PH", name: "countries.PH" },
  { code: "PK", name: "countries.PK" },
  { code: "PL", name: "countries.PL" },
  { code: "PM", name: "countries.PM" },
  { code: "PN", name: "countries.PN" },
  { code: "PR", name: "countries.PR" },
  { code: "PS", name: "countries.PS" },
  { code: "PT", name: "countries.PT" },
  { code: "PW", name: "countries.PW" },
  { code: "PY", name: "countries.PY" },
  { code: "QA", name: "countries.QA" },
  { code: "RE", name: "countries.RE" },
  { code: "RO", name: "countries.RO" },
  { code: "RS", name: "countries.RS" },
  { code: "RU", name: "countries.RU" },
  { code: "RW", name: "countries.RW" },
  { code: "SA", name: "countries.SA" },
  { code: "SB", name: "countries.SB" },
  { code: "SC", name: "countries.SC" },
  { code: "SD", name: "countries.SD" },
  { code: "SE", name: "countries.SE" },
  { code: "SG", name: "countries.SG" },
  { code: "SH", name: "countries.SH" },
  { code: "SI", name: "countries.SI" },
  { code: "SJ", name: "countries.SJ" },
  { code: "SK", name: "countries.SK" },
  { code: "SL", name: "countries.SL" },
  { code: "SM", name: "countries.SM" },
  { code: "SN", name: "countries.SN" },
  { code: "SO", name: "countries.SO" },
  { code: "SR", name: "countries.SR" },
  { code: "SS", name: "countries.SS" },
  { code: "ST", name: "countries.ST" },
  { code: "SV", name: "countries.SV" },
  { code: "SX", name: "countries.SX" },
  { code: "SY", name: "countries.SY" },
  { code: "SZ", name: "countries.SZ" },
  { code: "TC", name: "countries.TC" },
  { code: "TD", name: "countries.TD" },
  { code: "TF", name: "countries.TF" },
  { code: "TG", name: "countries.TG" },
  { code: "TH", name: "countries.TH" },
  { code: "TJ", name: "countries.TJ" },
  { code: "TK", name: "countries.TK" },
  { code: "TL", name: "countries.TL" },
  { code: "TM", name: "countries.TM" },
  { code: "TN", name: "countries.TN" },
  { code: "TO", name: "countries.TO" },
  { code: "TR", name: "countries.TR" },
  { code: "TT", name: "countries.TT" },
  { code: "TV", name: "countries.TV" },
  { code: "TW", name: "countries.TW" },
  { code: "TZ", name: "countries.TZ" },
  { code: "UA", name: "countries.UA" },
  { code: "UG", name: "countries.UG" },
  { code: "UM", name: "countries.UM" },
  { code: "US", name: "countries.US" },
  { code: "UY", name: "countries.UY" },
  { code: "UZ", name: "countries.UZ" },
  { code: "VA", name: "countries.VA" },
  { code: "VC", name: "countries.VC" },
  { code: "VE", name: "countries.VE" },
  { code: "VG", name: "countries.VG" },
  { code: "VI", name: "countries.VI" },
  { code: "VN", name: "countries.VN" },
  { code: "VU", name: "countries.VU" },
  { code: "WF", name: "countries.WF" },
  { code: "WS", name: "countries.WS" },
  { code: "XK", name: "countries.XK" },
  { code: "YE", name: "countries.YE" },
  { code: "YT", name: "countries.YT" },
  { code: "ZA", name: "countries.ZA" },
  { code: "ZM", name: "countries.ZM" },
  { code: "ZW", name: "countries.ZW" },
];

export default countries;
